// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__KfJkS","labelCertWasted":"certificate_labelCertWasted__5Vl3O","label":"certificate_label__mNn4s","hidden":"certificate_hidden__Iz8QK"};